import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NewContractFormService {

  public bearer: string|undefined;
}
